import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import styles from "./SideNav.module.css";
import companyStore from "../../Store/Store";
import { observable } from "mobx";
import { observer } from "mobx-react";
import axios from "axios";
import config from "../../config/config";

const SideNav = observer(({ closeTabs, className = "" }) => {
  const navigate = useNavigate();
  const [isOwner, setsOwner] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setsOwner(companyStore.isUserOwner);
  }, [companyStore.isUserOwner]);
  console.log("sideNav ", isOwner);

  const TransactionClick = useCallback(() => {
    navigate("/content/transactions");
    closeTabs();
  }, [navigate]);
  const TransactionClickStatement = useCallback(() => {
    navigate("/content/statement");
    closeTabs();
  }, [navigate]);

  const TransactionClick2 = useCallback(() => {
    navigate("/content/insights");
    closeTabs();
  }, [navigate]);

  const mainClick = useCallback(() => {
    navigate("/content/users");
    closeTabs();
  }, [navigate]);

  const mainClick5 = useCallback(() => {
    navigate("/content/add-users");
    closeTabs();
  }, [navigate]);

  const mainClick1 = useCallback(() => {
    navigate("/content/kyc");
    closeTabs();
  }, [navigate]);

  const mainClick2 = useCallback(() => {
    navigate("/content/categories");
    closeTabs();
  }, [navigate]);

  const mainClick3 = useCallback(() => {
    navigate("/content/config");
    closeTabs();
  }, [navigate]);

  const mainClick4 = useCallback(() => {
    navigate("/content/recovery");
    closeTabs();
  }, [navigate]);

  const mainClick6 = useCallback(() => {
    navigate("/content/loadMoney");
    closeTabs();
  }, [navigate]);

  const mainClick7 = useCallback(() => {
    navigate("/content/cupi-guide");
    closeTabs();
  }, [navigate]);
  const ProjectClick7 = useCallback(() => {
    navigate("/content/projects");
    closeTabs();
  }, [navigate]);

  const isActive = (path) => {
    if (path == location.pathname) {
      return true;
    }
    return false;
  };

  const NavigateToDashboard = async () => {
    let tokens = localStorage.getItem("authToken");
    let parsedTokens = JSON.parse(tokens);
    let obj = {
      ledger_label: companyStore.Company_Id,
    };
    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${config.node_api_endpoint}/cupi/admin/get_insights_dashboard_url`,
      headers: {
        aws_cognito_id_token: parsedTokens.IdToken,
        aws_cognito_access_token: parsedTokens.AccessToken,
        "Content-Type": "application/json",
      },
      data: obj,
    };
    axios
      .request(payload)
      .then((Res) => {
        console.log("Res.data.data.embedUrl", Res.data.data.embedUrl);
        if (Res?.data?.data?.embedUrl) {
          window.open(Res.data.data.embedUrl, "_blank");
        }
      })
      .catch((Er) => {
        console.log("Error While Redirecting to Insights ");
      });

    // console.log("response", response.data.embedUrl);
    // window.open(response.data.embedUrl, "_blank");
  };
  return (
    <div className={[styles.transaction, className].join(" ")}>
      <div>
        <div className={styles.finalCupiLogo}>
          <img className={styles.escrowLogo} alt="" src="/Final_Cupi.svg" />
        </div>
        <div className={styles.transactionParent}>
          {/* {companyStore.InsightAvilable && (
            <button
              className={
                isActive("/content/insights")
                  ? styles.transaction1Active
                  : styles.transactionHistoryWrapper
              }
              onClick={() => {
                NavigateToDashboard();
              }}
            >
              <img
                className={styles.personVcardIcon}
                src={
                  isActive("/content/insights")
                    ? "/line-chart-up-01.svg"
                    : "/line-chart-up-01(InActive).svg"
                }
                alt=""
              />
              <div className={styles.transactionHistory}>Insights</div>
            </button>
          )} */}
          <button
            className={
              isActive("/content/transactions")
                ? styles.transaction1Active
                : styles.transactionHistoryWrapper
            }
            onClick={TransactionClick}
          >
            <img
              className={styles.personVcardIcon}
              src={
                isActive("/content/transactions")
                  ? "/arrow-down-up(Active).svg"
                  : "/arrow-down-up.svg"
              }
              alt=""
            />
            <div className={styles.transactionHistory}>Expenses</div>
          </button>
          {/* {companyStore.userType=="AxisUser" &&      
        <button
          className={
            isActive("/content/ciesategor") 
              ? styles.transaction1Active
              : styles.transactionHistoryWrapper
          }
          id="Vendor_Management_Button"
        >
          <img
            className={styles.personVcardIcon}
            src={
              isActive("/content/catriesego")
                ? "/categorie(Active).svg"
                : "/Layer_1.svg"
            }
            alt=""
          />
          <div className={styles.userManagement}>Vendors</div>
        </button>} */}
          {/* {companyStore.userType == "PineLabUser" && (
            <button
              className={
                isActive("/content/kyc")
                  ? styles.transaction1Active
                  : styles.transactionHistoryWrapper
              }
              onClick={mainClick1}
            >
              <img
                className={styles.personVcardIcon}
                src={
                  isActive("/content/kyc")
                    ? "/kycicon(Active).svg"
                    : "/kycIcon.svg"
                }
                alt=""
              />
              <div className={styles.userManagement}>Add User</div>
            </button>
          )} */}
          {/* <button
            className={
              isActive("/content/add-users")
                ? styles.transaction1Active
                : styles.transactionHistoryWrapper
            }
            onClick={mainClick5}
          >
            <img
              className={styles.personVcardIcon}
              src={
                isActive("/content/add-users")
                  ? "/person-vcard(Active).svg"
                  : "/person-vcard.svg"
              }
              alt=""
            />
            <div className={styles.userManagement}>Add Users</div>
          </button> */}
          <button
            className={
              isActive("/content/users") || isActive("/content/bulkUser")
                ? styles.transaction1Active
                : styles.transactionHistoryWrapper
            }
            onClick={mainClick}
          >
            <img
              className={styles.personVcardIcon}
              src={
                isActive("/content/users") || isActive("/content/bulkUser")
                  ? "/person-vcard(Active).svg"
                  : "/person-vcard.svg"
              }
              alt=""
            />
            <div className={styles.userManagement}>Users</div>
          </button>
          <button
            className={
              isActive("/content/recovery")
                ? styles.transaction1Active
                : styles.transactionHistoryWrapper
            }
            onClick={mainClick4}
          >
            <img
              className={styles.personVcardIcon}
              src={
                isActive("/content/recovery")
                  ? "/journal-text(Active).svg"
                  : "/journal-text.svg"
              }
              alt=""
            />
            <div className={styles.userManagement}>Expense Recovery</div>
          </button>
          <button
            className={
              isActive("/content/categories")
                ? styles.transaction1Active
                : styles.transactionHistoryWrapper
            }
            onClick={mainClick2}
            id="Expense_Management_Button"
          >
            <img
              className={styles.personVcardIcon}
              src={
                isActive("/content/categories")
                  ? "/categorie(Active).svg"
                  : "/categorie.svg"
              }
              alt=""
            />
            <div className={styles.userManagement}>Expense Categories</div>
          </button>
          {companyStore.userType == "PineLabUser" && (
            <button
              className={
                isActive("/content/statement")
                  ? styles.transaction1Active
                  : styles.transactionHistoryWrapper
              }
              onClick={TransactionClickStatement}
            >
              <img
                className={styles.personVcardIcon}
                src={
                  isActive("/content/statement")
                    ? "/stmts_active.svg"
                    : "/stmts_inactive.svg"
                }
                alt=""
              />
              <div className={styles.transactionHistory}>Statement</div>
            </button>
          )}

          <button
            className={
              isActive("/content/config")
                ? styles.transaction1Active
                : styles.transactionHistoryWrapper
            }
            onClick={mainClick3}
            id="Expense_Management_Button"
          >
            <img
              className={styles.personVcardIcon}
              src={
                isActive("/content/config")
                  ? "/settings-03.svg"
                  : "/settings-03(NotActive).svg"
              }
              alt=""
            />
            <div className={styles.userManagement}>Expense Settings</div>
          </button>

          {companyStore.userType == "PineLabUser" && (
            <button
              className={
                isActive("/content/loadMoney")
                  ? styles.transaction1Active
                  : styles.transactionHistoryWrapper
              }
              onClick={mainClick6}
              id="Expense_Management_Button"
            >
              <img
                className={styles.personVcardIcon}
                src={
                  isActive("/content/loadMoney")
                    ? "/Load_Money(Active).svg"
                    : "/Load_Money(inActive).svg"
                }
                alt=""
              />
              <div className={styles.userManagement}>Load Money</div>
            </button>
          )}
          <button
            className={
              isActive("/content/cupi-guide")
                ? styles.transaction1Active
                : styles.transactionHistoryWrapper
            }
            onClick={mainClick7}
            id="Expense_Management_Button"
          >
            <img
              className={styles.personVcardIcon}
              src={
                isActive("/content/cupi-guide")
                  ? "/CupiGuide_Active.svg"
                  : "/CupiGuide_InActive.svg"
              }
              alt=""
            />
            <div className={styles.userManagement}>Cupi Guide</div>
          </button>

          {/* <button
            className={
              isActive("/content/projects")
                ? styles.transaction1Active
                : styles.transactionHistoryWrapper
            }
            onClick={ProjectClick7}
            id="Expense_Management_Button"
          >
            <img
              className={styles.personVcardIcon}
              src={
                isActive("/content/projects")
                  ? "/ProjectIcon(Active).svg"
                  : "/ProjectIcon(InActive).svg"
              }
              alt=""
            />
            <div className={styles.userManagement}>Projects</div>
          </button> */}
        </div>
      </div>
      {companyStore.userType == "PineLabUser" && (
        <div className={styles.finalCupiLogo1}>
          <img className={styles.escrowLogo1} alt="" src="/PineLabsLogo.svg" />
        </div>
      )}
    </div>
  );
});

SideNav.propTypes = {
  className: PropTypes.string,
};

export default SideNav;
